// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"490":"f4fb087e","2005":"04dd9607","3456":"f7f284d7","6201":"d0be82fc","8026":"c7a03aa0","8698":"10e4500f"}[chunkId] || chunkId) + ".25.0.39.js";
};